import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function login(email, password) {
    const postData = { email, password };
    return axios.post(`${API_BASE_URL}/auth/login`, postData);
}

export function formatError(errorResponse) {
    if (!errorResponse || !errorResponse.error) return 'Error';
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    console.log('💾 [saveTokenInLocalStorage] Saving token to localStorage:', { 
        access_token: tokenDetails.access_token ? 'present' : 'missing',
        idToken: tokenDetails.idToken ? 'present' : 'missing',
        expiresIn: tokenDetails.expiresIn 
    });
    // Map access_token to idToken for compatibility
    const now = new Date();
    const expiresInMs = tokenDetails.expiresIn * 1000; // expiresIn is in seconds, convert to ms
    const calculatedExpireDate = new Date(now.getTime() + expiresInMs);
    
    console.log('💾 [saveTokenInLocalStorage] Calculating expireDate:', {
        now: now.toISOString(),
        expiresIn: tokenDetails.expiresIn,
        expiresInMs: expiresInMs,
        expiresInMsInSeconds: expiresInMs / 1000,
        expiresInMsInHours: expiresInMs / (1000 * 60 * 60),
        expiresInMsInDays: expiresInMs / (1000 * 60 * 60 * 24),
        calculatedExpireDate: calculatedExpireDate.toISOString(),
        timeDifference: calculatedExpireDate.getTime() - now.getTime()
    });
    
    // Save expireDate as ISO string to avoid serialization issues
    const expireDateISO = calculatedExpireDate.toISOString();
    
    const tokenData = {
        ...tokenDetails,
        idToken: tokenDetails.access_token || tokenDetails.idToken || '',
        expireDate: expireDateISO, // Save as string ISO to avoid Date serialization issues
    };
    console.log('💾 [saveTokenInLocalStorage] Final tokenData to save:', { 
        access_token: tokenData.access_token ? 'present' : 'missing',
        idToken: tokenData.idToken ? 'present' : 'missing',
        expireDate: expireDateISO,
        expireDateType: typeof tokenData.expireDate
    });
    
    const serialized = JSON.stringify(tokenData);
    console.log('💾 [saveTokenInLocalStorage] Serialized data length:', serialized.length, 'characters');
    localStorage.setItem('userDetails', serialized);
    console.log('💾 [saveTokenInLocalStorage] Token saved to localStorage successfully');
}

// Global variable to track the logout timer
let logoutTimerId = null;

export function runLogoutTimer(dispatch, timer, navigate) {
    console.log('⏰⏰⏰ [runLogoutTimer] FUNCTION CALLED - FIRST LINE');
    console.trace('⏰⏰⏰ [runLogoutTimer] CALL STACK');
    console.log('⏰ [runLogoutTimer] CALLED with:', { 
        timer, 
        timerType: typeof timer,
        timerSeconds: timer ? timer / 1000 : 'N/A',
        timerHours: timer ? timer / (1000 * 60 * 60) : 'N/A',
        isNaN: isNaN(timer),
        isFinite: isFinite(timer),
        rawValue: timer
    });
    
    // Clear any existing logout timer first
    if (logoutTimerId !== null) {
        console.log('⏰ [runLogoutTimer] Clearing existing timer:', logoutTimerId);
        clearTimeout(logoutTimerId);
        logoutTimerId = null;
    } else {
        console.log('⏰ [runLogoutTimer] No existing timer to clear');
    }
    
    // Validate timer is positive and valid number
    if (!timer || timer <= 0 || isNaN(timer) || !isFinite(timer)) {
        console.error('⏰ [runLogoutTimer] Invalid timer:', timer, {
            isNull: timer === null,
            isUndefined: timer === undefined,
            isZero: timer === 0,
            isNegative: timer < 0,
            isNaN: isNaN(timer),
            isFinite: isFinite(timer)
        });
        return;
    }
    
    // Validate timer is reasonable (at least 100 seconds for debugging)
    // IMPORTANT: setTimeout maximum is 2^31 - 1 ms (2147483647 ms ≈ 24.8 days)
    const minTimer = 100 * 1000; // 100 seconds (allow short timers for debugging)
    const MAX_SETTIMEOUT_MS = 2147483647; // 2^31 - 1 (maximum value for setTimeout)
    
    if (timer < minTimer) {
        console.error('⏰ [runLogoutTimer] Timer too short (less than 100 seconds):', timer, 'ms. Not setting timer.');
        return;
    }
    
    // Cap timer at setTimeout maximum (24.8 days)
    // For longer periods, we'll use a periodic check approach
    let actualTimer = timer;
    if (timer > MAX_SETTIMEOUT_MS) {
        console.warn('⏰ [runLogoutTimer] Timer exceeds setTimeout maximum (', MAX_SETTIMEOUT_MS, 'ms), capping to maximum:', {
            requested: timer,
            requestedDays: timer / (1000 * 60 * 60 * 24),
            maxAllowed: MAX_SETTIMEOUT_MS,
            maxAllowedDays: MAX_SETTIMEOUT_MS / (1000 * 60 * 60 * 24),
            actualTimer: MAX_SETTIMEOUT_MS,
            actualTimerDays: MAX_SETTIMEOUT_MS / (1000 * 60 * 60 * 24)
        });
        actualTimer = MAX_SETTIMEOUT_MS;
    }
    
    console.log('⏰ [runLogoutTimer] Setting logout timer for', actualTimer / 1000, 'seconds (', actualTimer / (1000 * 60 * 60), 'hours,', actualTimer / (1000 * 60 * 60 * 24), 'days)');
    console.log('⏰ [runLogoutTimer] About to call setTimeout with timer:', {
        originalTimer: timer,
        actualTimer: actualTimer,
        timerType: typeof actualTimer,
        timerValue: actualTimer,
        timerIsValid: !isNaN(actualTimer) && isFinite(actualTimer) && actualTimer > 0,
        isCapped: timer > MAX_SETTIMEOUT_MS
    });
    console.trace('⏰ [runLogoutTimer] Call stack for setting timer:');
    
    // Double check actualTimer value right before setTimeout
    if (!actualTimer || actualTimer <= 0 || isNaN(actualTimer) || !isFinite(actualTimer)) {
        console.error('⏰ [runLogoutTimer] FATAL: Timer is invalid right before setTimeout:', actualTimer);
        return;
    }
    
    // Store the original timer value and actual timer value
    const originalTimer = timer;
    const storedTimerValue = actualTimer;
    const timerStartTime = Date.now();
    
    // If the original timer is longer than the max, we need to check periodically
    // For now, we'll just cap it and the user will need to refresh before 24 days
    const remainingTime = originalTimer - actualTimer;
    
    logoutTimerId = setTimeout(() => {
        const actualElapsed = Date.now() - timerStartTime;
        console.log('⏰ [runLogoutTimer] Timer expired, logging out');
        console.log('⏰ [runLogoutTimer] Timer callback executed');
        console.log('⏰ [runLogoutTimer] Original requested duration:', originalTimer / 1000, 'seconds (', originalTimer / (1000 * 60 * 60 * 24), 'days)');
        console.log('⏰ [runLogoutTimer] Actual timer set for:', storedTimerValue / 1000, 'seconds (', storedTimerValue / (1000 * 60 * 60 * 24), 'days)');
        console.log('⏰ [runLogoutTimer] Actual elapsed:', actualElapsed / 1000, 'seconds');
        
        // If there's remaining time, we should check localStorage and potentially re-extend
        if (remainingTime > 0) {
            console.log('⏰ [runLogoutTimer] There was remaining time (', remainingTime / 1000, 'seconds), checking if token is still valid...');
            // Check localStorage to see if token is still valid
            const tokenDetailsString = localStorage.getItem('userDetails');
            if (tokenDetailsString) {
                try {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const expireDate = new Date(tokenDetails.expireDate);
                    const now = new Date();
                    const timeRemaining = expireDate.getTime() - now.getTime();
                    
                    if (timeRemaining > 0) {
                        console.log('⏰ [runLogoutTimer] Token still valid, extending timer for remaining time:', timeRemaining / 1000, 'seconds');
                        // Re-set timer with remaining time (capped at max)
                        logoutTimerId = null;
                        runLogoutTimer(dispatch, Math.min(timeRemaining, MAX_SETTIMEOUT_MS), navigate);
                        return;
                    } else {
                        console.log('⏰ [runLogoutTimer] Token expired, logging out');
                    }
                } catch (e) {
                    console.error('⏰ [runLogoutTimer] Error checking token:', e);
                }
            } else {
                console.log('⏰ [runLogoutTimer] No token in localStorage, logging out');
            }
        }
        
        logoutTimerId = null;
        dispatch(Logout(navigate));
    }, actualTimer);
    
    console.log('⏰ [runLogoutTimer] Timer set successfully:', {
        timerId: logoutTimerId,
        originalTimerValue: timer,
        actualTimerValue: actualTimer,
        timerSeconds: actualTimer / 1000,
        timerHours: actualTimer / (1000 * 60 * 60),
        timerDays: actualTimer / (1000 * 60 * 60 * 24),
        wasCapped: timer > MAX_SETTIMEOUT_MS,
        timestamp: new Date().toISOString()
    });
}

export function checkAutoLogin(dispatch, navigate) {
    console.log('🔍 [checkAutoLogin] Starting auto login check...');
    const tokenDetailsString = localStorage.getItem('userDetails');
    console.log('🔍 [checkAutoLogin] localStorage userDetails:', tokenDetailsString ? 'present' : 'missing');
    
    if (!tokenDetailsString) {
        console.log('🔍 [checkAutoLogin] No token in localStorage');
        // Only logout if we're not already on login page
        if (window.location.pathname !== '/login') {
            console.log('🔍 [checkAutoLogin] Not on login page, calling Logout');
            dispatch(Logout(navigate));
        } else {
            console.log('🔍 [checkAutoLogin] Already on login page, skipping Logout');
        }
        return;
    }

    try {
        const tokenDetails = JSON.parse(tokenDetailsString);
        console.log('🔍 [checkAutoLogin] Parsed token details:', { 
            access_token: tokenDetails.access_token ? 'present' : 'missing',
            idToken: tokenDetails.idToken ? 'present' : 'missing',
            expireDate: tokenDetails.expireDate 
        });
        
        // Check if we have a valid token (access_token or idToken)
        if (!tokenDetails.access_token && !tokenDetails.idToken) {
            console.log('🔍 [checkAutoLogin] No valid token in localStorage');
            // Only logout if we're not already on login page
            if (window.location.pathname !== '/login') {
                console.log('🔍 [checkAutoLogin] Not on login page, calling Logout');
                dispatch(Logout(navigate));
            }
            return;
        }

        console.log('🔍 [checkAutoLogin] Raw expireDate from localStorage:', {
            expireDateRaw: tokenDetails.expireDate,
            expireDateRawType: typeof tokenDetails.expireDate,
            expireDateRawString: String(tokenDetails.expireDate)
        });
        
        let expireDate = new Date(tokenDetails.expireDate);
        let todaysDate = new Date();
        
        console.log('🔍 [checkAutoLogin] Parsed dates:', {
            expireDate: expireDate.toISOString(),
            expireDateTimestamp: expireDate.getTime(),
            todaysDate: todaysDate.toISOString(),
            todaysDateTimestamp: todaysDate.getTime(),
            isExpired: todaysDate > expireDate,
            isValidDate: !isNaN(expireDate.getTime()),
            timeDifference: expireDate.getTime() - todaysDate.getTime(),
            timeDifferenceSeconds: (expireDate.getTime() - todaysDate.getTime()) / 1000,
            timeDifferenceHours: (expireDate.getTime() - todaysDate.getTime()) / (1000 * 60 * 60),
            timeDifferenceDays: (expireDate.getTime() - todaysDate.getTime()) / (1000 * 60 * 60 * 24)
        });

        // Check if expireDate is valid
        if (isNaN(expireDate.getTime())) {
            console.error('🔍 [checkAutoLogin] Invalid expireDate, cannot parse:', tokenDetails.expireDate);
            return;
        }

        if (todaysDate > expireDate) {
            // Token expired, logout
            console.log('🔍 [checkAutoLogin] Token expired, calling Logout');
            dispatch(Logout(navigate));
            return;
        }
        
        // Map access_token to idToken if needed
        const authData = {
            ...tokenDetails,
            idToken: tokenDetails.access_token || tokenDetails.idToken || '',
        };
        console.log('🔍 [checkAutoLogin] Dispatching loginConfirmedAction with authData');
        dispatch(loginConfirmedAction(authData));
        
        const timer = expireDate.getTime() - todaysDate.getTime();
        console.log('🔍 [checkAutoLogin] Calculated timer:', { 
            timerMs: timer, 
            timerSeconds: timer / 1000,
            timerHours: timer / (1000 * 60 * 60),
            isValidTimer: timer > 0,
            timerValue: timer
        });
        
        // IMPORTANT: Don't set timer if there's already an active timer from login
        if (logoutTimerId !== null) {
            console.log('🔍 [checkAutoLogin] Timer already active from login, NOT overwriting it. TimerId:', logoutTimerId);
            return;
        }
        
        // Only set timer if it's positive (future expiration) and greater than 100 seconds
        // This prevents setting very short timers that could fire immediately
        if (timer > 0 && timer > 100 * 1000) {
            console.log('🔍 [checkAutoLogin] Setting logout timer for', timer / 1000, 'seconds');
            runLogoutTimer(dispatch, timer, navigate);
        } else {
            console.error('🔍 [checkAutoLogin] Invalid timer (negative, zero, or too short):', timer, 'ms. Not setting logout timer.');
            if (timer <= 0) {
                console.error('🔍 [checkAutoLogin] Timer is negative or zero - token may already be expired or expireDate is invalid');
            } else if (timer <= 100 * 1000) {
                console.error('🔍 [checkAutoLogin] Timer is too short (less than 100 seconds) - likely a calculation error');
            }
        }
    } catch (e) {
        console.error('❌ [checkAutoLogin] Error:', e);
        // Invalid JSON, only logout if not on login page
        if (window.location.pathname !== '/login') {
            console.log('🔍 [checkAutoLogin] Error parsing, calling Logout');
            dispatch(Logout(navigate));
        }
    }
}
